<div
  class="summary-container severity severity--{{
    dnaSyngoviaScoreSeverityService.scoreSeverity(healthcheckSummary.totalScore)
  }}"
>
  <div class="summary-message">
    <sh-icon
      icon="{{ healthcheckSummary.totalScore === 0 ? 'success' : 'warning' }}"
      size="s"
    ></sh-icon>
    <sh-text size="header-2" class="summary-description">
      {{ healthcheckSummary.description ?? '-' }}
    </sh-text>
  </div>

  <div class="score-container">
    <span class="score-date">
      <sh-text size="title-1" color="secondary">
        {{ 'syngovia.label.totalHealthcheckScore' | translate }}
      </sh-text>
      <sh-text size="body-1" color="secondary">
        {{ 'syngovia.label.On' | translate }}
        {{ healthcheckSummary.totalScoreUpdateDate | localizedDate }}
      </sh-text>
    </span>
    <sh-text class="score">
      {{ healthcheckSummary.totalScore ?? '-' }}
    </sh-text>
  </div>
</div>
